<template>
    <div class="story-maker-sticker story-maker-sticker-post">
        <img class="img-change-color" :src="require('@/assets/img/instagram/ehf.png')">
        <p class="text-finish">{{ $t('dash.post-creator.story.done') }}</p>
        <div class="sticker-post" :class="[typePost, `styleVariant${styleVariant}`, aspectRatioComputed > 0.5625 ? 'containX' : 'containY']">
           <div v-if="styleVariant == 2" class="sticker-post-header">
                <img :src="avatar || ($attrs.pageSelected && $attrs.pageSelected.avatar ? $attrs.pageSelected.avatar : 'img/avatar.jpg')">
                <p>{{ pageName || ($attrs.pageSelected ? $attrs.pageSelected.name : 'auteur') }}</p>
           </div>
            <video v-if="typeComputed == 'video'" data-check-load :src="urlComputed" :type="fileTypeComputed" :muted="mutedSound" playsinline loop autoplay preload="metadata" class="video media-post" @loadedmetadata="e => e.target.muted = mutedSound">
            </video>
            <img v-else class="selectDisable media-post" draggable="false" data-check-load :src="urlComputed">

            <div v-if="styleVariant == 2 && textContent && textContent.length && !/^(<br\s*\/?>|\\n|\s*)+$/i.test(textContent)" class="sticker-post-footer">
                <p><span class="page-name">{{ pageName || ($attrs.pageSelected ? $attrs.pageSelected.name : 'auteur') }}</span>{{ textContent }}</p>
            </div>
            <p v-if="styleVariant == 1" class="namePage">{{typePost !== 'reel' ? '@' : ''}}{{ pageName || ( $attrs.pageSelected ? $attrs.pageSelected.name : 'auteur' )}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            id: Number | String,
            idFile: Number | String,
            files:Object,
            url: String,
            width: Number,
            height: Number,
            type: 'image' | 'video',
            fileType: String,
            typePost: String,
            textContent: 'simple' | 'carousel' | 'reel',
            pageName: String,
            avatar: String,
            styleVariant: {
                default: 1,
                type: Number
            },
            setCbClick: Function,
            mutedSound: {
                default: true,
                type: Boolean
            },
        },



        mounted () {
            if (this.setCbClick) this.setCbClick(this.changeStyleVariant);
        },
        methods: {
            changeStyleVariant(e) {
                this.$emit('updateSticker',this.id , {
                    data : {
                        ...this.$attrs.data,
                        styleVariant :(this.styleVariant % 2) + 1
                    },
                })
            }
        },
        computed: {
            urlComputed() {
                if (this.url) return this.url
                if (this.idFile && this.files[this.idFile]) return this.files[this.idFile].url
            },
            fileTypeComputed() {
                if (this.fileType) return this.fileType;
                if (this.idFile && this.files[this.idFile]) return this.files[this.idFile].info.type;
            },
            typeComputed() {
                if (this.fileType) return this.type;
                if (this.idFile && this.files[this.idFile]) return this.files[this.idFile].info.type2;
            },
            aspectRatioComputed() {
                if (this.width > 0 && this.height > 0) return this.width / this.height
                if (this.idFile && this.files[this.idFile]) return this.files[this.idFile].info.aspectRatio
            },

        },
    }
</script>
